import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/home/Section2.css';

const Section2 = () => {
  return (
    <section className="hero-section-dark">
      {/* Image placeholder container - now on the left */}
      <div className="image-container-dark">
        <div className="image-placeholder-dark"></div>
      </div>

      <div className="content-container-dark">
        <h1 className="main-heading-dark">Signal Trust, Win Loyalties Early</h1>
        <p className="subtext-dark">College students aren’t just future customers; they’re
          future brand leaders. When you invest in them now, you don’t just build goodwill. 
          You build a long-term commitment.</p>
        
        <div className="cta-container-dark">
          <Link to="/brands"><button className="learn-more-btn-dark">Learn More</button></Link>
        </div>
      </div>
    </section>
  );
};

export default Section2;